import IconOnlyButton from './IconOnlyButton';
export default IconOnlyButton;
